import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppContextProvider } from './components/AppContext';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <AppContextProvider>
        <App />
    </AppContextProvider>
);